<template>
    <div>
        <a-form-item :label="$t('Tablo')">
            <a-select v-model="localValue.table" @change="handleTableChange">
                <a-select-option v-for="table in tables" :key="table._id" :value="table._id">
                    {{ table.name }}
                </a-select-option>
            </a-select>
        </a-form-item>

        <a-form-item :label="$t('Bağlantı Türü')">
            <a-select v-model="localValue.connectionType" @change="handleConnectionTypeChange">
                <a-select-option value="_id">ID</a-select-option>
                <a-select-option value="field">{{ $t('Alan') }}</a-select-option>
            </a-select>
        </a-form-item>

        <a-form-item v-if="localValue.connectionType === 'field'" :label="$t('Alan')">
            <a-select v-model="localValue.field">
                <a-select-option 
                    v-for="field in getTableFields(localValue.table)" 
                    :key="field._id" 
                    :value="field._id"
                >
                    {{ field.name }}
                </a-select-option>
            </a-select>
        </a-form-item>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: Object,
            required: true
        },
        tables: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            localValue: this.value
        }
    },
    methods: {
        getTableFields(tableId) {
            const table = this.tables.find(t => t._id === tableId);
            return table?.fields || [];
        },
        handleTableChange() {
            this.$emit('input', this.localValue);
        },
        handleConnectionTypeChange() {
            if (this.localValue.connectionType === '_id') {
                this.localValue.field = null;
            }
            this.$emit('input', this.localValue);
        }
    },
    watch: {
        value: {
            deep: true,
            handler(newVal) {
                this.localValue = newVal;
            }
        }
    }
}
</script> 